import { styled } from '@linaria/react';
import { newCOLORS } from '../../styles/colors';

export const DropShadowContainer = styled.div`
  position: relative;
  height: 100%;
  background-color: ${newCOLORS.white};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 15px;
  display: flex;
  flex-direction: column;
`;
